import { useMemo } from 'react';
import { isBigInt } from '../../utils/helpers.ts';
import { useBlockchainCurrentRoundNumber } from '../../contexts/blockchain';
import { useGameRoundDataBlockchainQuery } from './useGameRoundDataBlockchainQuery.ts';

export const useCurrentGameRoundDataBlockchainQuery = (
  queryConfig?: QueryConfig
) => {
  const currentRoundNumber = useBlockchainCurrentRoundNumber();

  const roundDataQuery = useGameRoundDataBlockchainQuery(currentRoundNumber, {
    enabled: queryConfig?.enabled !== false && isBigInt(currentRoundNumber),
  });

  return useMemo(
    () => ({
      ...roundDataQuery,
      data: [currentRoundNumber, roundDataQuery.data] as const,
    }),
    [currentRoundNumber, roundDataQuery]
  );
};

type QueryConfig = {
  enabled?: boolean;
};
